import { useTranslation } from '@/i18n/useTranslation';

import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './useAuth';
import { FullPageSpinner } from '@/components/common/FullPageSpinner';
import { InlineError } from '@/components/common/InlineError';
import { LoginPage } from '@/pages/LoginPage';

/**
 * Route wrapper for every authenticated page. Unauthenticated users remain on
 * the login page until they sign in with a local account.
 */
export function RequireAuth() {
  const { t } = useTranslation();
  const { isAuthenticated, isInitializing, isProfileLoading, profileError, currentUser } =
    useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <LoginPage />;
  }
  if (isInitializing) {
    return <FullPageSpinner label={t('Refreshing your session…')} />;
  }
  if (isProfileLoading) {
    return <FullPageSpinner label={t('Loading your profile…')} />;
  }
  if (profileError) {
    return <InlineError error={profileError} />;
  }
  if (currentUser?.must_change_password && location.pathname !== '/profile') {
    return <Navigate to="/profile" replace />;
  }

  return <Outlet />;
}
